export enum ApiKeysLoaderKey {
  LIST_API_KEYS = 'list-api-keys',
  CREATE_API_KEY = 'create-api-key',
  DELETE_API_KEY = 'delete-api-key',
  UPDATE_API_KEY = 'update-api-key',
  GET_API_KEY = 'get-api-key'
}
